import React, { FC } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import { SvgIcon } from '../../../icons/SvgIcon';
import { allTournamentsCollapsed$$ } from '../subs';
import { toggleAllTournaments } from '../handlers';
import clsx from 'clsx';

const ToggleTournaments: FC<{ sportName: string; className?: string }> = ({ sportName, className, children }) => {
    const derefSub = useReframe();
    const collapsedAll = derefSub(allTournamentsCollapsed$$(sportName));
    const imgId = collapsedAll ? 'live-collapse-tournaments-out' : 'live-collapse-tournaments';
    return (
        <button
            onClick={() => dispatch(toggleAllTournaments(sportName))}
            data-atid="tlv-toggle-tournaments"
            className={clsx(className)}
        >
            {children || <SvgIcon imgId={imgId} sizeX="20" sizeY="20" />}
        </button>
    );
};

export default ToggleTournaments;
